import React from "react"
import {FieldManagementFormCFV1Props} from "../../../../render/management-form-cf-v1"

import FieldInternalDatabase from "../internal-database"
import {FieldManagementFormProps} from "../../../../render/management-form"
import {CustomFieldScope} from "../../../../../model2/custom-field/@const"
import ErrorBoundary from "../../../../../error-boundary"
import FieldManagementLeftPanel from "../../../../proto/render/management/panel/form-left-panel"
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import FormRowFlex from "../../../../../gd-form/form/form-flex/row"
import FormError from "../../../../../gd-form/common/form-error/form-error"
import CustomField_FromRowScope from "../../../../../fields/custom/common/form-scope"
import ButtonSubmitDeprecated from "../../../../../gd-form/common/btn-submit/btn-submit-ui5"
import FormManager from "../../../../../gd-form/common/form-manager"
import {EntityType} from "../../../../../gd/const/item"
import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const"
import SelectParentNew from "../../../../../gd-ui/select-parent-new/select-parent-new"
import ProjectSessionCollection from "../../../../../model2/project/collection"
import CustomFieldName from "../../../../../fields/custom/common/form-name"
import CustomFieldDisplayName from "../../../../../fields/custom/common/form-display-name"
import CustomFieldAccess from "../../../../../fields/custom/common/form-access"

// const debug = "FieldInternalDatabase_ManagementFormCFV1"
const debug = false

export default class FieldInternalDatabase_ManagementFormCFV1 extends React.Component<FieldManagementFormCFV1Props> {

    public form         : FormManager
    public field        : FieldInternalDatabase

    constructor(props:FieldManagementFormProps) {
        super(props)

        this.field = this.props.field as FieldInternalDatabase

        const initFormData = {
            name            : this.field.label || '',
            displayName     : this.props.field.fieldParams.displayName,
            description     : _.get(this.field, 'description', ''),
            access          : _.get(this.field, 'fieldAccess', gd.const.customFields.access.EVERYONE),
            scope           : this.field.fieldParams.scope || [CustomFieldScope.TASK],
            projectId       : this.field.fieldParams.referenceProjectId,
        }

        const formStructure = {
            fields: {
                name       : {
                    type: 'input',
                    isRequired: true,
                    label: 'Label',
                    validator: (val:any) => {
                        let res:any = true;
                        if (val === null || val === undefined || val.trim() === '') {
                            res = 'Invalid label';
                        }
                        return res;
                    },
                    onUserChange: this.onLabelChange
                },
                displayName       : {
                    type        : 'input',
                    isRequired  : false,
                    label       : 'Display label',
                },

                access : { type: 'select',     isRequired: true,   label: 'Access'},

                scope       : {
                    type        : 'input',
                    isRequired  : true
                },

                projectId: {
                    type        : 'select',
                    isRequired  : true,
                    label       : 'Project Id'
                }
            },
            onSubmit: this.onSubmit
        }

        this.form = new FormManager(formStructure, initFormData)
    }

    onLabelChange = () => {
        this.forceUpdate()
    }

    onParentChange = (projectId: ID) => {
        this.form?.onFormComponentValueChange('projectId', projectId)
    }

    onSubmit = (result:any) => {
        debug && console.log(debug, 'onSubmit', result)

        this.field.label                  = result.name.trim()
        this.field.fieldAccess            = result.access

        this.field.fieldParams    = {
            displayName         : result.displayName?.trim(),
            scope               : result.scope,
            referenceProjectId  : result.projectId,
        }

        debug && console.log(debug, 'onSubmit field', this.field)

        // field is an object so we never return anything in here
        this.props.onSubmit(this.field)
    }

    render() {
        const availableProjects = new ProjectSessionCollection(gd.databases.projects)

        return (
            <>
                <ErrorBoundary>
                    <FieldManagementLeftPanel field={this.field} />
                </ErrorBoundary>

                <ErrorBoundary>

                    <div className="iv-cf-form">
                        <VScroll className="iv-cf-scroll">

                            <div className="iv-header header-left header-small-no-separator">
                                <div className="title-line">
                                    <div className="view-name">
                                        <div className="ui5-title-app-name max-w-350 ">New Custom Field</div>
                                    </div>
                                </div>
                            </div>

                            <div className="iv-content with-left-panel">
                                <div className="p-l-30">
                                    <div className="ui5-form size-30-70">
                                        <div className="f-tbl">
                                            <CustomFieldName form={this.form}/>
                                            <CustomFieldDisplayName form={this.form}/>
                                            <CustomFieldAccess form={this.form}/>

                                            <CustomField_FromRowScope form={this.form} mandatoryScope={this.props.mandatoryScope || []}/>

                                            <FormRowFlex label="Database project">
                                                <SelectParentNew parentsFor         = {EntityType.TASK}
                                                                 renderType         = {SelectParent_RenderType.FORM}
                                                                 availableProjects  = {availableProjects}
                                                                 projectId          = {this.form.getValue('projectId')}
                                                                 hideEmptySections  = {true}
                                                                 onChange           = {this.onParentChange}/>
                                                <FormError form={this.form} name="projectId" />
                                            </FormRowFlex>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </VScroll>

                        <div className="bottom-action">
                            <ButtonSubmitDeprecated form={this.form} className="submit" label="Save"/>
                        </div>
                    </div>
                </ErrorBoundary>
            </>
        )
    }
}
